export default __webpack_public_path__ + "static/media/seasoned_hunters_bow.bc6a42aa.png";